import React, { FC } from 'react'

import * as S from './styles'
import { contentsWrapperProps } from './types'

const ContentsWrapper: FC<contentsWrapperProps> = ({ children }) => {
  return (
    <S.ContentsContainer>
      <S.TableContainer>
        <S.ChildrenScrollWrapper isChildrenExist={!!children}>
          <div>{children}</div>
        </S.ChildrenScrollWrapper>
      </S.TableContainer>
    </S.ContentsContainer>
  )
}

export default ContentsWrapper
